var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lable-i-group theme-lable-i-group"},_vm._l((_vm.statusList),function(item){return _c('div',{key:item,staticClass:"label-i",staticStyle:{"margin-right":"3px"}},[_vm._v(_vm._s(item))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }